//import mutations from './mutations'

/**
 *
 * @param {*} param0
 * @param {*} param1 array with all the parameters that snackbar-modal needs to show itself properly
 */
const initSnackbar = function({ dispatch }, payload) {
    dispatch('setType', payload.typeMessage)
    dispatch('setMessage', payload.message)
    dispatch('showProgress', payload.showProgress)
    if (payload.timeout == 0 && !payload.showCloseBtn) {
        // If timeout is 0, snackbar HAS to have a close button.
        dispatch('showCloseBtn', {
            showCloseBtn: true,
            closeBtnMessage: 'cerrar',
        })
    } else {
        dispatch('showCloseBtn', {
            showCloseBtn: payload.showCloseBtn,
            closeBtnMessage: payload.closeBtnMessage,
        })
    }
    dispatch('showSnack', payload.timeout)
}

const resetSnackbarState = function({ commit }) {
    commit('RESET')
}

const setType = function({ commit }, typePayLoad) {
    commit('SET_TYPE', typePayLoad)
}

const setMessage = function({ commit }, message) {
    commit('SET_MESSAGE', message)
}

const showProgress = function({ commit }, progress) {
    commit('SET_PROGRESS', progress)
}

const hideSnack = function({ commit }) {
    commit('HIDE')
}

const showSnack = function({ commit }, timeout) {
    commit('SHOW', timeout)
}

/**
 *
 * @param {*} param0
 * @param {*} text
 */
const showCloseBtn = function({ commit }, payload) {
    commit('SHOW_CLOSE_BUTTON', payload)
}

const hideCloseBtn = function({ commit }) {
    commit('HIDE_CLOSE_BUTTON')
}

const setMessageConfirmSnack = function({ commit }, msg) {
    commit('SET_MESSAGE_CONFIRM', msg)
}

const responseConfirm = function({ commit }, identifier) {
    commit('RESPONSE_HAS_BEEN_CONFIRMED', identifier)
}

const setAlignTop = function({ commit }, payload) {
    // payload has to be true or false
    commit('SET_ALIGN_TOP', payload)
}

/**
 *
 */
const setSnackbar = (context, options) => {
    context.commit('RESET')
    context.commit('SET_TYPE', options.type)
    context.commit('SET_MESSAGE', {
        body: options.message,
        title: options.title,
    })
    context.commit('SHOW_CLOSE_BUTTON', {
        showCloseBtn: true,
        closeBtnMessage: 'cerrar',
    })
    context.commit('SHOW', options.timeout)

    if (options.confirm) {
        context.commit('SET_MESSAGE_CONFIRM', options.confirm)
    }
}

/**
 *
 */
const setErrorSnackbar = (context, body) => {
    context.commit('RESET')
    context.commit('SET_TYPE', 'error')
    context.commit('SET_MESSAGE', { body, title: 'Error' })
    context.commit('SHOW_CLOSE_BUTTON', {
        showCloseBtn: true,
        closeBtnMessage: 'cerrar',
    })
    context.commit('SHOW', 3000)
}

/**
 *
 */
const setInfoSnackbar = (context, body) => {
    context.commit('RESET')
    context.commit('SET_TYPE', 'info')
    context.commit('SET_MESSAGE', { body, title: 'Información.' })
    context.commit('SHOW_CLOSE_BUTTON', {
        showCloseBtn: true,
        closeBtnMessage: 'cerrar',
    })
    context.commit('SHOW', 5000)
}

/**
 *
 */
const setSuccessSnackbar = (context, body) => {
    context.commit('RESET')
    context.commit('SET_TYPE', 'success')
    context.commit('SET_MESSAGE', { body, title: 'Éxito' })
    context.commit('SHOW_CLOSE_BUTTON', {
        showCloseBtn: true,
        closeBtnMessage: 'cerrar',
    })
    context.commit('SHOW', 3000)
}

/**
 *
 */
const setWaitingSnackbar = (context, options) => {
    context.commit('RESET')
    context.commit('SET_TYPE', 'info')
    context.commit('SET_MESSAGE', {
        body: options,
        title: 'Esperando',
    })
    context.commit('SHOW_CLOSE_BUTTON', {
        showCloseBtn: false,
        closeBtnMessage: 'cerrar',
    })
    //context.commit('SET_MESSAGE_CONFIRM', options.confirm)
    context.commit('SHOW', null)
}

/**
 *
 */
const setWarningSnackbar = (context, options) => {
    context.commit('RESET')
    context.commit('SET_TYPE', options.color || 'warning')
    context.commit('SET_MESSAGE', {
        body: options.message,
        title: options.title,
    })
    context.commit('SHOW_CLOSE_BUTTON', {
        showCloseBtn: true,
        closeBtnMessage: 'cerrar',
    })
    context.commit('SET_MESSAGE_CONFIRM', options.confirm)
    context.commit('SHOW', null)
}

/**
 * Sets the progress snackbar state.
 *
 * @param      {<type>}  context  The context
 * @param      {<type>}  options  The options
 */
const setProgressSnackbarState = (context, options) => {
    context.commit('HIDE_CONFIRM_BUTTON', true)
    context.commit('HIDE_CLOSE_BUTTON', true)
    context.commit('SET_PROGRESS', true)
}

//
export default {
    initSnackbar,
    setMessage,
    setType,
    showProgress,
    hideSnack,
    showSnack,
    showCloseBtn,
    hideCloseBtn,
    resetSnackbarState,
    setMessageConfirmSnack,
    responseConfirm,
    setAlignTop,
    setSnackbar,
    setErrorSnackbar,
    setInfoSnackbar,
    setSuccessSnackbar,
    setWaitingSnackbar,
    setWarningSnackbar,
    setProgressSnackbarState,
}
